export default __webpack_public_path__ + "static/media/DASHPORT_isotipo_W.b3782122.png";